import { render } from "./ButtonReturn.vue?vue&type=template&id=217297c4"
import script from "./ButtonReturn.vue?vue&type=script&lang=js"
export * from "./ButtonReturn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__